<div class="w-100 float-left text-13x">
    <div class="w-100 float-left">
        <div class="w-100 float-left">
            <div class="w-100 float-left mb-3 hidden-actions">
                <i class="fa float-left mr-3 mt-1 text-20x" *ngIf="hasChilds()"
                   [ngClass]="showChild ? 'fa-caret-down' : 'fa-caret-right'"
                   (click)=toggleChild();></i>
                <label for="user1" class="mb-md-0 float-left mr-2 mt-1"></label>
                <p class="float-left text-14x m-0 "> {{org.orgName}}
                    <span class="show-actions float-right" style="display: none;">
                        <i class="fa fa-plus cursor ml-4 pointer text-10x p-1 rounded text-primary border-primary"
                           (click)="addSubLevels(!asl)">
                            <span class="medium text-primary pl-1">{{'addChild' | translate}}</span>
                        </i>
                        <i class="fa fa-edit cursor ml-1 pointer text-10x p-1 rounded text-primary border-primary"
                           (click)="editOrg(org)">
                                <span class="medium text-primary pl-1">{{'edit' | translate}}</span>
                            </i>
                        <i class="fa fa-close cursor ml-1 pointer text-10x text-danger border-danger p-1 rounded"
                           (click)="deleteOrgModal()">
                            <span class="medium text-danger pl-1">{{'delete' | translate}}</span>
                        </i>
                        <ng-template #tipContent> {{'orgName' | translate}} :  {{org.orgName}}<br>{{'orgCode' | translate}} :  {{org.orgUnitCode}}<br>{{'orgType' | translate}} :  {{getOrgtype()}}</ng-template>
                        <i class="fa fa-info cursor ml-1 pointer text-10x text-success border-success p-1 rounded"
                           [ngbTooltip]="tipContent">
                            <span class="medium text-success pl-1" placement="top">{{'info' | translate}}</span>
                        </i>
                    </span>
                </p>

            </div>
            <AddOrganization *ngIf="asl" [parentOrg]='org.id' (cancelEvent)="closeSubLevels(!asl)"
                             (addOrgEvent)="addChildTree($event)"></AddOrganization>
            <child-orgs [childOrgs]="org.childOrgs" (refresh)="refreshLocal($event)"
                        *ngIf="org.childOrgs && showChild"></child-orgs>
            <!-- </div> -->
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/tools/org/org.html